export const UTM_SOURCE_QUERY = 'utm_source';
export const COME_FROM_INTEREST_UID_QUERY = 'comeFromInterestQuery';
export const INTEREST_SECTION_UID_QUERY = 'interestSectionUidQuery';
export const MOBILE_BREAK_POINT = 684;
export const TABLED_BREAK_POINT = 1193;
export const PRIVACY_POLICY_LINK =
  'https://www.digitalturbine.com/notice-at-collection-and-privacy-policy-cm/';
export const TERMS_OF_SERVICE_LINK =
  'https://www.digitalturbine.com/terms-of-use/';
export const PRIVACY_POLICY_LINK_ES =
  'https://www.digitalturbine.com/legal/notice-at-collection-and-privacy-policy-spanish';
export const TERMS_OF_SERVICE_LINK_ES =
  'https://www.digitalturbine.com/legal/cm-app-terms-of-service-es';
export const UTM_SOURCE_SKFOTOSCAPE = 'mp-ckfotoscapes';
